import { DateRange } from 'react-day-picker';
import { isValid } from 'date-fns';
import { formatQueryDate, parseInputDate } from 'utils';
import { Parameters } from 'constants/queryParameters';
import { useQuerySearchParams } from './useQuerySearchParams';

export const useQueryDateRange = (): [DateRange, (r: DateRange) => void] => {
  const [range, setRange] = useQuerySearchParams<[string, string]>(Parameters.dateRange);

  const startParsed = range?.[0] ? parseInputDate(range[0]) : undefined;
  const endParsed = range?.[1] ? parseInputDate(range[1]) : undefined;

  const value = {
    from: isValid(startParsed) ? startParsed : undefined,
    to: isValid(endParsed) ? endParsed : undefined,
  };

  const setValue = (range: DateRange) => {
    setRange(
      [
        range.from ? formatQueryDate(range.from) : '',
        range.to ? formatQueryDate(range.to) : '',
      ],
      { replace: true },
    );
  };

  return [value, setValue];
};
